<script>
import { groupBy } from "lodash";
import PropertyTableCard from "./property-table-card.vue";
export default {
    name: "PropertyList",
    components: {
        PropertyTableCard
    },
    props: {
        getByValue: {
            type: Number,
            default: 1,
        },
        employeeData: {
            type: Object,
            default: null,
        },
        tableData: {
            type: Array,
            default: () => [],
        },
        busy: {
            type: Boolean,
            default: false,
        },
        selectedProperties: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            tabIndex: 0,
            filter: "",
            perPage: 10,
            currentPage: 1,
            pageOptions: [10, 25, 50, 100],
            pageOptionsSm: [5, 10, 25, 50, 100],
            sortBy: "id",
            sortDesc: true,
            fields: [
                {
                    key: "poNumber",
                    sortable: true,
                    label: "Purchase Order"
                }
            ],
            propertyFields: [
                {
                    key: "Name",
                    sortable: true
                }
            ],
            assignmentHistoryEmployeeData: null,
            assignmentHistoryLocationData: null,
        };
    },
    computed: {
        grouped() {
            if (this.tabIndex == 1) {
                var array = [];
                var x = groupBy(this.filtered, "supplier");
                for (const key in x) {
                    var supplier = key;
                    var y = groupBy(x[key], "poNumber");
                    for (const key in y) {
                        array.push({
                            poNumber: key,
                            supplier: supplier,
                            details: y[key],
                            toggleAll: false,
                            showDetails: false,
                            rotateChevy: false,
                            currentPage: 1,
                            perPage: 5,
                            filter: "",
                            tableBusy: false
                        });
                    }
                }
                return array;
            } 
            return this.filtered;
        },
        rows() {
            return this.grouped.length;
        },
        filtered() {
            let data = this.tableData;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey.toLowerCase().includes(this.filter.toLowerCase());
                });
            }
            return data;
        },
        displayResults(){
            return `Showing ${(this.currentPage - 1) * this.perPage + 1} - ${this.rows > (this.currentPage - 1) * this.perPage + this.perPage ? (this.currentPage - 1) * this.perPage + this.perPage : this.rows} of ${this.rows}`;
        }
    },
    methods: {
        checkCart(row) {
            var index = this.selectedProperties.findIndex((x) => x.id == row.id);
            if (index == -1) return true;
            else return false;
        },
        employeeName(empData){
            return `${empData.firstName.charAt(0).toUpperCase() + empData.firstName.slice(1)} ${empData.middleName ? `${empData.middleName.charAt(0).toUpperCase()}.` : ""} ${empData.lastName.charAt(0).toUpperCase() + empData.lastName.slice(1)}`;
        },
        propertyRows(row) {
            if (row.filter.trim() != "" && row.filter) {
                return this.propertyFiltered(row).length;
            } else {
                return row.details.length;
            }
        },
        displayResultsSub(row) {
            const total = this.propertyFiltered(row).length;
            const currentPage = row.currentPage;
            const perPage = row.perPage;
            return `Showing ${(currentPage - 1) * perPage + 1} - ${total > (currentPage - 1) * perPage + perPage ? (currentPage - 1) * perPage + perPage : total} of ${total}`;
        },
        addAllToCart(props, currentPage, perPage) {
            var data = JSON.parse(JSON.stringify(props));
            var total = currentPage * perPage;
            var currentData = data.reverse().slice(total - perPage, total);
            if (currentPage > 1 && currentData.length == 0) {
                total = (currentPage - 1) * perPage;
                currentData = data.slice(total - perPage, total);
            }
            var count = 0;
            currentData.forEach((item) => {
                if (this.checkCart(item)) {
                    this.selectedProperties.push(item);
                    count = count + 1;
                }
            });
            this.setCartProperties();
            if (count > 0) {
                this.showToast(`All visible properties in page ${currentPage} are added to cart.`, "info");
            } else {
                this.showToast(`All visible properties in page ${currentPage} has already been added to cart.`, "warning");
            }
        },
        removeAllFromCart(props, currentPage, perPage) {
            var data = JSON.parse(JSON.stringify(props));
            var total = currentPage * perPage;
            var currentData = data.reverse().slice(total - perPage, total);
            if (currentPage > 1 && currentData.length == 0) {
                total = (currentPage - 1) * perPage;
                currentData = data.slice(total - perPage, total);
            }
            var count = 0;
            currentData.forEach((item) => {
                var index = this.selectedProperties.findIndex((x) => x.id == item.id);
                if (index != -1) {
                    this.selectedProperties.splice(index, 1);
                    count = count + 1;
                }
            });
            this.setCartProperties();
            if (count > 0) {
                this.showToast(`All visible properties in page ${currentPage} are removed from cart.`, "success"); 
            } else {
                this.showToast(`All visible properties in page ${currentPage} are not yet added in cart.`, "warning");
            }
        },
        setCartProperties() {
            localStorage.setItem("selectedProperties", JSON.stringify(this.selectedProperties));
        },
        async getProperty(row) {
            row.item.rotateChevy = !row.item.rotateChevy;
            row.item.showDetails = !row.item.showDetails;
            if (this.getByValue == 2) {
                row.item.details = [];
                if (row.item.showDetails) {
                row.item.tableBusy = true;
                await this.wait(1000);
                await this.$store
                    .dispatch("property/GetPropertybyPO", {
                        poNumber: row.item.poNumber,
                        status: 'POSTED',
                        campusId: this.$store.state.data.selectedCampus.id
                    })
                    .then((res) => {
                        res.data.forEach((item) => {
                        item.visible = false;
                        item.itemVisible = false;
                        item.assignmentHistory = [];
                        item.assignVisible = false;
                        item.assignLoading = false;
                        item.inventory = [];
                        item.inventoryVisible = false;
                        item.inventoryLoading = false;
                        item.inspectionVisible = false;
                        item.attachmentVisible = false;
                        item.attachmentLoading = false;
                        item.addDocu = false;
                        item.fileSearch = "";
                        item.propertyInspections.forEach((inspect) => {
                            inspect.inspectionFiles = [];
                            inspect.attachmentLoading = false;
                        });
                        });
                        row.item.details = res.data;
                        row.item.tableBusy = false;
                    })
                    .catch(() => {
                        row.item.tableBusy = false;
                        this.showToast("Something went wrong - Getting property list!", "error");
                    });
                }
            }
        },
        checkPropertyType(row) {
            var PAR = 0;
            var ICS = 0;
            row.forEach((item) => {
                if (item.amount >= 50000) PAR++;
                else ICS++;
            });
            if (PAR == 0 && ICS == 0) return 0;
            else if (PAR > 0 && ICS == 0) return 1;
            else if (PAR == 0 && ICS > 0) return 2;
            else if (PAR > 0 && ICS > 0) return 3;
        },
        checkIfPAR(details) {
            return this.checkPropertyType(details) == 1 || this.checkPropertyType(details) == 3;
        },
        checkIfICS(details) {
            return this.checkPropertyType(details) == 2 || this.checkPropertyType(details) == 3;
        },
        printPAR(item){
            if(this.employeeData){
                this.$emit('print-par-by-employee', {poNumber: item.poNumber, id: this.employeeData.idNo})
            }else{
                this.$emit('print-par-po', item.poNumber)
            }
        },
        printICS(item){
            if(this.employeeData){
                this.$emit('print-ics-by-employee', {poNumber: item.poNumber, id: this.employeeData.idNo})
            }else{
                this.$emit('print-ics-po', item.poNumber)
            }
        },
        propertyFiltered(row) {
            let data = row.details;
            if (row.filter.trim() != "" && row.filter) {
                data = data.filter((item) => {
                    return item.filterKey.toLowerCase().includes(row.filter.toLowerCase());
                });
            }
            return data;
        },
    }
}
</script>
<template>
    <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
        <b-tab>
            <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                <i class="mdi mdi-shopping-outline"></i>
                </span>
                <span class="d-none d-sm-inline-block">Show All</span>
            </template>
            <div v-if="tabIndex == 0" class="card border-4 border-top border-start-0 border-end-0 border-primary">
                <div class="card-body">
                    <div class="row mb-1">
                        <div class="col-md-6">
                            <div>
                                <h5 class="m-0 mb-1">List of Properties</h5>
                                <transition name="fade">
                                <h6 v-if="employeeData && employeeData.firstName" class="m-0 d-flex align-items-center">
                                    {{
                                    employeeData.firstName.charAt(0).toUpperCase() +
                                    employeeData.firstName.slice(1)
                                    }}
                                    {{
                                    employeeData.middleName
                                        ? `${employeeData.middleName
                                        .charAt(0)
                                        .toUpperCase()}.`
                                        : ""
                                    }}
                                    {{
                                    employeeData.lastName.charAt(0).toUpperCase() +
                                    employeeData.lastName.slice(1)
                                    }}
                                    <i @click="showEmployee(employeeData)" v-b-tooltip.top.hover="'Print Records'"
                                    class="bx bx-printer text-purple font-size-18 cursor-pointer ms-1"></i>
                                </h6>
                                </transition>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex float-end align-items-center">
                                <transition name="fade">
                                    <div 
                                        v-if="filtered.length" 
                                        class="d-flex align-items-center"
                                    >
                                        <b-button 
                                            :title="`Add ${filter.trim() == '' ? '' : 'Searched '}Properties to Cart`" 
                                            class="me-1" 
                                            @click="addAllToCart(grouped, currentPage, perPage)" 
                                            variant="outline-info"
                                        >
                                            <i class="mdi mdi-cart-outline"></i>
                                        </b-button>
                                        <b-button 
                                            :title="`Remove ${filter.trim() == '' ? '' : 'Searched '}Properties from Cart`" 
                                            class="me-2" 
                                            @click="removeAllFromCart(grouped, currentPage, perPage)" 
                                            variant="outline-danger"
                                        >
                                            <i class="mdi mdi-cart-remove"></i>
                                        </b-button>
                                    </div>
                                </transition>
                                <div id="tickets-table_filter" class="dataTables_filter me-1">
                                <label class="d-inline-flex align-items-center mb-0">
                                    <b-form-input autocomplete="off" v-model="filter" type="search" @input="currentPage = 1"
                                    placeholder="Search Property..." class="form-control"></b-form-input>
                                </label>
                                </div>
                                <div id="tickets-table_length" class="dataTables_length">
                                <label class="d-inline-flex align-items-center mb-0">
                                    <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptions">
                                    </b-form-select>
                                </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="custom-table-responsive mb-0 mt-2">
                        <b-table 
                            class="propertyTable datatables target-table" 
                            :items="grouped" 
                            :fields="propertyFields"
                            responsive="sm" 
                            :per-page="perPage" 
                            :current-page="currentPage" 
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc" 
                            :busy="busy" 
                            bordered 
                            outlined 
                            striped 
                            show-empty
                        >
                            <template #empty>
                                <b-card-header>
                                    <div class="text-center">
                                        <div v-if="filter != ''">
                                            <i class="fas fa-exclamation-triangle me-2"></i>There are no properties matching your request
                                        </div>
                                        <div v-else>
                                            <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                                        </div>
                                    </div>
                                </b-card-header>
                            </template>
                            <template #table-busy>
                                <b-card-header>
                                    <div class="d-flex justify-content-center align-items-center p-2">
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div class="spinner-chase w-20px h-20px">
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                <div class="chase-dot"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </b-card-header>
                            </template>
                            <template #cell(name)="propertyRow">
                                <PropertyTableCard 
                                    :isCheckCart="checkCart(propertyRow.item)"
                                    :propertyRow="propertyRow" 
                                    :currentPage="currentPage"
                                    :perPage="perPage"
                                    :assignmentHistoryEmployeeData="assignmentHistoryEmployeeData"
                                    :assignmentHistoryLocationData="assignmentHistoryLocationData"
                                    @add-to-cart="$emit('add-to-cart', propertyRow.item)"
                                    @remove-from-cart="$emit('remove-from-cart', propertyRow.item)"
                                    @print-par="$emit('print-par', [propertyRow.item.id])"
                                    @print-ics="$emit('print-ics', [propertyRow.item.id])"
                                    @print-sticker="$emit('print-sticker', propertyRow.item.id)"
                                    @print-property-card="$emit('print-property-card', propertyRow.item.id)"
                                    @update-item="$emit('update-item', {props: propertyRow.item, po: null})"
                                />
                            </template>
                        </b-table>
                    </div>
                    <div class="row">
                        <div v-if="rows > 0" class="col">
                            {{ displayResults }}
                        </div>
                        <div class="col">
                            <div class="dataTables_paginate paging_simple_numbers float-end">
                                <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-tab>
        <b-tab>
            <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                <i class="mdi mdi-filter-outline"></i>
                </span>
                <span class="d-none d-sm-inline-block">Filter by PO</span>
            </template>
            <div v-if="tabIndex == 1" class="card border-4 border-top border-start-0 border-end-0 border-primary">
                <div class="card-body">
                    <div class="row mb-1">
                        <div class="col-md-6">
                            <div>
                                <h5 class="m-0 mb-1">List of Properties</h5>
                                <transition name="fade">
                                    <h6 v-if="employeeData && employeeData.firstName" class="m-0 d-flex align-items-center">
                                        {{ employeeName(employeeData) }}
                                        <i @click="showEmployee(employeeData)" v-b-tooltip.top.hover="'Print Records'"
                                        class="bx bx-printer text-purple font-size-18 cursor-pointer ms-1"></i>
                                    </h6>
                                </transition>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex float-end align-items-center">
                                <div id="tickets-table_filter" class="dataTables_filter me-1">
                                    <label class="d-inline-flex align-items-center mb-0">
                                        <b-form-input 
                                            autocomplete="off" 
                                            v-model="filter" 
                                            type="search" 
                                            @input="currentPage = 1"
                                            placeholder="Search Property..." 
                                            class="form-control"
                                        />
                                    </label>
                                </div>
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center mb-0">
                                        <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptions">
                                        </b-form-select>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="custom-table-responsive mb-0 mt-2">
                        <b-table 
                            class="propertyTable datatables target-table" 
                            :items="grouped" 
                            :fields="fields"
                            responsive="sm" 
                            :per-page="perPage" 
                            :current-page="currentPage" 
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc" 
                            :busy="busy" 
                            bordered 
                            outlined 
                            striped 
                            show-empty
                        >
                            <template #empty>
                                <b-card-header>
                                <div class="text-center">
                                    <div v-if="filter != ''">
                                    <i class="fas fa-exclamation-triangle me-2"></i>There are no POs matching your request
                                    </div>
                                    <div v-else>
                                    <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                                    </div>
                                </div>
                                </b-card-header>
                            </template>
                            <template #table-busy>
                                <b-card-header>
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="preloader-component me-2">
                                    <div class="status">
                                        <div class="spinner-chase w-20px h-20px">
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                    </div>
                                    <strong>Loading...</strong>
                                </div>
                                </b-card-header>
                            </template>
                            <template #cell(poNumber)="row">
                                <b-card-header 
                                    header-tag="header" 
                                    @click="getProperty(row)" 
                                    class="cursor-pointer border"
                                    role="tab"
                                >
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <b class="text-white">{{ row.value ? `PO# ${row.value}` : "No Recorded PO" }}</b>  
                                            <div>{{ row.item.supplier ? row.item.supplier : "No Recorded Supplier" }}</div>
                                        </div>
                                        <div>
                                            <i 
                                                class="bx bx-chevron-right rotate font-size-16 cursor-pointer" 
                                                :class="{'rotate-90': row.item.rotateChevy}">
                                            </i>
                                        </div>
                                    </div>
                                </b-card-header>
                                <b-collapse :visible="row.item.showDetails">
                                    <b-card 
                                        no-body
                                        class="p-3 shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0"
                                    >
                                        <div>
                                            <div class="d-flex align-items-center float-end mb-2">
                                                <b-button 
                                                    title="Add Visible Properties to Cart" 
                                                    class="btn-sm me-1" 
                                                    @click="addAllToCart(propertyFiltered(row.item), row.item.currentPage, row.item.perPage)" 
                                                    variant="outline-info"
                                                >
                                                    <i class="mdi mdi-cart-outline"></i>
                                                </b-button>
                                                <b-button 
                                                    title="Remove All from Cart" 
                                                    class="btn-sm" 
                                                    @click="removeAllFromCart(propertyFiltered(row.item), row.item.currentPage, row.item.perPage)"
                                                    variant="outline-danger"
                                                >
                                                    <i class="mdi mdi-cart-remove"></i>
                                                </b-button>
                                                <b-dropdown 
                                                    id="dropdown-dropleft" 
                                                    right 
                                                    variant="link"
                                                    toggle-class="text-decoration-none" 
                                                    menu-class="dropdown-menu-end" 
                                                    no-caret
                                                >
                                                    <template #button-content>
                                                        <button type="button"
                                                            class="btn btn-sm btn-purple d-flex align-items-center m-0">
                                                            <i class="bx bx-printer fs-6 me-1"></i>Print Documents
                                                        </button>
                                                    </template>
                                                    <b-dropdown-item 
                                                        v-if="checkIfPAR(row.item.details)" 
                                                        @click="printPAR(row.item)"
                                                    >
                                                        <i class="bx bx-printer font-size-18 text-purple me-1"></i>
                                                        Print PAR by PO
                                                    </b-dropdown-item>
                                                    <b-dropdown-item 
                                                        v-if="checkIfICS(row.item.details)"
                                                        @click="printICS(row.item)"
                                                    >
                                                        <i class="bx bx-printer font-size-18 text-purple me-1"></i>
                                                        Print ICS by PO
                                                    </b-dropdown-item>
                                                    <b-dropdown-item>
                                                        <i class="bx bx-printer font-size-18 text-purple me-1"></i>
                                                        Print RIS by PO
                                                    </b-dropdown-item>
                                                    <b-dropdown-item 
                                                        @click="$emit('print-sticker-by-po', row.item.poNumber)"
                                                    >
                                                        <i class="bx bx-printer font-size-18 text-purple me-1"></i>
                                                        Print Sticker by PO
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                                <div id="tickets-table_filter" class="dataTables_filter me-1">
                                                    <label class="d-inline-flex align-items-center mb-0">
                                                        <b-form-input 
                                                            autocomplete="off" 
                                                            v-model="row.item.filter" 
                                                            type="search"
                                                            placeholder="Search Property..."
                                                            class="form-control form-control-sm"
                                                        ></b-form-input>
                                                    </label>
                                                </div>
                                                <div id="tickets-table_length" class="dataTables_length">
                                                    <label class="d-inline-flex align-items-center mb-0">
                                                        <b-form-select 
                                                            class="form-select form-select-sm" 
                                                            v-model="row.item.perPage"
                                                            size="sm" 
                                                            :options="pageOptionsSm"
                                                        >
                                                        </b-form-select>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-0">
                                            <b-table 
                                                class="propertyTable datatables target-table" 
                                                thead-class="d-none"
                                                :items="propertyFiltered(row.item)" 
                                                :fields="propertyFields" 
                                                responsive="sm"
                                                :per-page="row.item.perPage" 
                                                :current-page="row.item.currentPage" 
                                                sort-by="id"
                                                :sort-desc.sync="sortDesc" 
                                                :busy="row.item.busy" 
                                                show-empty
                                            >
                                                <template #empty>
                                                    <b-card-header>
                                                        <div class="text-center">
                                                            <div v-if="row.item.filter != ''">
                                                                <i class="fas fa-exclamation-triangle me-2"></i>
                                                                There are no properties matching your request
                                                            </div>
                                                            <div v-else>
                                                                <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                                                            </div>
                                                        </div>
                                                    </b-card-header>
                                                </template>
                                                <template #table-busy>
                                                    <b-card-header>
                                                        <div class="d-flex justify-content-center align-items-center p-2">
                                                            <div class="preloader-component me-2">
                                                                <div class="status">
                                                                    <div class="spinner-chase w-20px h-20px">
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <strong>Loading...</strong>
                                                        </div>
                                                    </b-card-header>
                                                </template>
                                                <template #cell(name)="propertyRow">
                                                    <PropertyTableCard 
                                                        :propertyRow="propertyRow" 
                                                        :isCheckCart="checkCart(propertyRow.item)"
                                                        :currentPage="currentPage"
                                                        :perPage="perPage"
                                                        :assignmentHistoryEmployeeData="assignmentHistoryEmployeeData"
                                                        :assignmentHistoryLocationData="assignmentHistoryLocationData"
                                                        @add-to-cart="$emit('add-to-cart', propertyRow.item)"
                                                        @remove-from-cart="$emit('remove-from-cart', propertyRow.item)"
                                                        @print-par="$emit('print-par', [propertyRow.item.id])"
                                                        @print-ics="$emit('print-ics', [propertyRow.item.id])"
                                                        @print-sticker="$emit('print-sticker', propertyRow.item.id)"
                                                        @print-property-card="$emit('print-property-card', propertyRow.item.id)"
                                                        @update-item="$emit('update-item', {props: propertyRow.item, po: null})"
                                                    />
                                                </template>
                                            </b-table>
                                        </div>
                                        <div class="row">
                                            <div v-if="propertyRows(row.item) > 0" class="col">
                                                {{ displayResultsSub(row.item) }}
                                            </div>
                                            <div class="col">
                                            <div class="dataTables_paginate paging_simple_numbers float-end">
                                                <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                                                    <b-pagination 
                                                        v-model="row.item.currentPage"
                                                        :total-rows="propertyRows(row.item)"
                                                        :per-page="row.item.perPage"
                                                    />
                                                </ul>
                                            </div>
                                            </div>
                                        </div>
                                    </b-card>
                                </b-collapse>
                            </template>
                        </b-table>
                    </div>
                    <div class="row">
                        <div v-if="rows > 0" class="col">
                            {{ displayResults }}
                        </div>
                        <div class="col">
                            <div class="dataTables_paginate paging_simple_numbers float-end">
                                <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-tab>
    </b-tabs>
</template>